import React, { Component, Fragment } from 'react'
import Menu from '../components/Menu'
import TopBarLayout from '../layouts/TopBarLayout'

class SessionLayout extends Component {
  render() {
    const { title, children } = this.props

    return (
      <Fragment>
        <Menu icon="fas fa-bars">
          <Menu.Logo />
          <Menu.Divider />
          <Menu.Link to="/patient-session/learn" str="titles.learn" icon="fas fa-graduation-cap" />
          <Menu.Link to="/patient-session/use" str="titles.use" icon="fas fa-eye-dropper" />
          <Menu.Link to="/patient-session/goal" str="titles.goal" icon="fas fa-thumbs-up" />
          <Menu.Link to="/patient-session/adherence" str="titles.adherence" icon="fas fa-chart-bar" />
          <Menu.Divider />
          <Menu.LanguageSwitcher />
          <Menu.QuitLink to={`/logout`} str="titles.signOut" icon="fas fa-chevron-left" />
        </Menu>
        <TopBarLayout title={title}>
          {children}
        </TopBarLayout>
      </Fragment>
    )
  }
}

export default SessionLayout



// WEBPACK FOOTER //
// ./src/layouts/PatientSessionLayout.js